import React from 'react';

export interface OptionsUser {
  icon: JSX.Element;
  text: string;
  action: () => void;
  disabled?: boolean;
  separatorAbove?: boolean;
  textClass?: string;
}

interface IUserOptionsProps {
  options: OptionsUser[];
  containerClass?: string;
  isVisible: boolean;
}

const UserOptions = ({
  options,
  containerClass = '',
  isVisible,
}: IUserOptionsProps): JSX.Element => {
  return (
    <>
      {isVisible ? (
        <div className="user-options-external-container">
          <div className={`user-options-internal-container ${containerClass}`}>
            {options.map((option) => (
              <>
                {option.separatorAbove && <hr />}
                <button
                  data-cy={`UserOption${option.text}`}
                  className="user-options-info-container btn"
                  key={crypto.randomUUID()}
                  onClick={option.action}
                  disabled={option.disabled}
                >
                  {option.icon}
                  <p className={`${option.textClass ? option.textClass : ''}`}>
                    {option.text}
                  </p>
                </button>
              </>
            ))}
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default UserOptions;
